module.exports = __webpack_public_path__ + "img/digitalticket_teiki_big.46299df9.svg";